import { IWhatsAppState, WhatsAppAction, initialWhatsAppState } from "./WhatsApp.types";

export const whatsAppReducer = (state: IWhatsAppState, action: WhatsAppAction): IWhatsAppState => {
  switch (action.type) {
    // ─── CONTACTS ────────────────────────────────────────
    case "CONTACTS_LOADING":
      return { ...state, contactList: { ...state.contactList, loading: true, error: null } };

    case "CONTACTS_SUCCESS":
      return {
        ...state,
        contactList: {
          ...state.contactList,
          loading: false,
          list: [...state.contactList.list, ...action.payload.data],
          totalRecords: action.payload.totalRecords,
          hasMoreRecords: action.payload.data.length > 0,
          message: action.payload.message,
          meta: action.payload.meta,
          error: null,
        },
      };

    case "CONTACTS_FAILED":
      return { ...state, contactList: { ...state.contactList, loading: false, error: action.payload.error } };

    case "CONTACTS_NOT_SCANNED":
      return { ...state, contactList: { ...state.contactList, loading: false, error: "WHATSAPP_NOT_SCANNED" } };

    case "CONTACTS_SERVICE_OFF":
      return { ...state, contactList: { ...state.contactList, loading: false, error: "WHATSAPP_SERVICE_OFF" } };

    case "CONTACTS_CLEAR":
      return { ...state, contactList: { ...initialWhatsAppState.contactList } };

    case "CONTACTS_SET":
      return { ...state, contactList: { ...state.contactList, list: action.payload.contacts } };

    case "SET_ACTIVE_CHAT":
      return { ...state, activeChat: action.payload };

    // ─── ACTION EVENTS ───────────────────────────────────
    case "EVENTS_LOADING":
      return { ...state, actionEventList: { ...state.actionEventList, loading: "loading", list: [], error: null } };

    case "EVENTS_SUCCESS":
      return {
        ...state,
        actionEventList: {
          ...state.actionEventList,
          loading: "loaded",
          list: action.payload.data,
          totalRecords: action.payload.totalRecords,
          hasMoreRecords: action.payload.data.length > 0,
          error: null,
        },
      };

    case "EVENTS_FAILED":
      return { ...state, actionEventList: { ...state.actionEventList, loading: "failed", error: action.payload.error } };

    case "EVENTS_CLEAR":
      return { ...state, actionEventList: { ...initialWhatsAppState.actionEventList } };

    // ─── MEDIA HISTORY ───────────────────────────────────
    case "MEDIA_LOADING":
      return { ...state, mediaHistory: { ...state.mediaHistory, loading: "loading", list: [], error: null } };

    case "MEDIA_SUCCESS":
      return {
        ...state,
        mediaHistory: {
          loading: "loaded",
          list: action.payload.data,
          currentRecords: action.payload.currentRecords,
          error: null,
        },
      };

    case "MEDIA_FAILED":
      return { ...state, mediaHistory: { ...state.mediaHistory, loading: "failed", error: action.payload.error } };

    // ─── CONTACT ASSIGNEES ───────────────────────────────
    case "ASSIGNEES_LOADING":
      return { ...state, contactAssignees: { ...state.contactAssignees, loading: "loading", error: null } };

    case "ASSIGNEES_SUCCESS":
      return { ...state, contactAssignees: { list: action.payload.data, loading: "loaded", error: null } };

    case "ASSIGNEES_FAILED":
      return { ...state, contactAssignees: { ...state.contactAssignees, loading: "failed", error: action.payload.error } };

    // ─── MODULE SETTINGS ─────────────────────────────────
    case "MODULE_SETTINGS_LOADING":
      return { ...state, moduleSettings: { ...state.moduleSettings, loading: "loading" } };

    case "MODULE_SETTINGS_SUCCESS":
      return { ...state, moduleSettings: { list: action.payload.data, loading: "loaded" } };

    case "MODULE_SETTINGS_FAILED":
      return { ...state, moduleSettings: { ...state.moduleSettings, loading: "failed" } };

    default:
      return state;
  }
};
